module.exports = __webpack_public_path__ + "img/logo.00feb2f3.png";